// extracted by mini-css-extract-plugin
module.exports = {"user-page-header":"header_user-page-header__2oMYO","admin-page-header":"header_admin-page-header__3JOiR","agrisud-header":"header_agrisud-header__2ccy6"};